module.exports = __webpack_public_path__ + "img/icon-share.0388c04c.svg";